export default {
"villagercolors":[
  {
    "id": "cbr19",
    "name": "Judy",
    "url": "https://nookipedia.com/wiki/Judy",
    "skin_color": "ffebff",
    "text_color": "725661"
  },
  {
    "id": "wol12",
    "name": "Audie",
    "url": "https://nookipedia.com/wiki/Audie",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "cbr05",
    "name": "Stitches",
    "url": "https://nookipedia.com/wiki/Stitches",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "cat23",
    "name": "Raymond",
    "url": "https://nookipedia.com/wiki/Raymond",
    "skin_color": "acc8cf",
    "text_color": "498992"
  },
  {
    "id": "squ15",
    "name": "Poppy",
    "url": "https://nookipedia.com/wiki/Poppy",
    "skin_color": "db6161",
    "text_color": "fffce9"
  },
  {
    "id": "duk16",
    "name": "Molly",
    "url": "https://nookipedia.com/wiki/Molly",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "shp15",
    "name": "Dom",
    "url": "https://nookipedia.com/wiki/Dom",
    "skin_color": "feeae7",
    "text_color": "97858e"
  },
  {
    "id": "der07",
    "name": "Beau",
    "url": "https://nookipedia.com/wiki/Beau",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "rbt02",
    "name": "Coco",
    "url": "https://nookipedia.com/wiki/Coco",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "cbr01",
    "name": "Maple",
    "url": "https://nookipedia.com/wiki/Maple",
    "skin_color": "a87850",
    "text_color": "fffce9"
  },
  {
    "id": "pgn01",
    "name": "Roald",
    "url": "https://nookipedia.com/wiki/Roald",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "dog02",
    "name": "Lucky",
    "url": "https://nookipedia.com/wiki/Lucky",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "goa09",
    "name": "Sherb",
    "url": "https://nookipedia.com/wiki/Sherb",
    "skin_color": "bff2ff",
    "text_color": "85a2af"
  },
  {
    "id": "cat19",
    "name": "Ankha",
    "url": "https://nookipedia.com/wiki/Ankha",
    "skin_color": "fff80d",
    "text_color": "9b8986"
  },
  {
    "id": "cat00",
    "name": "Bob",
    "url": "https://nookipedia.com/wiki/Bob",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "hrs13",
    "name": "Julian",
    "url": "https://nookipedia.com/wiki/Julian",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "pbr00",
    "name": "Apollo",
    "url": "https://nookipedia.com/wiki/Apollo",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "cat16",
    "name": "Merry",
    "url": "https://nookipedia.com/wiki/Merry",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "cat09",
    "name": "Kabuki",
    "url": "https://nookipedia.com/wiki/Kabuki",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "wol04",
    "name": "Dobie",
    "url": "https://nookipedia.com/wiki/Dobie",
    "skin_color": "798040",
    "text_color": "fffad4"
  },
  {
    "id": "cbr14",
    "name": "Pekoe",
    "url": "https://nookipedia.com/wiki/Pekoe",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "wol03",
    "name": "Whitney",
    "url": "https://nookipedia.com/wiki/Whitney",
    "skin_color": "bff2ff",
    "text_color": "85a2af"
  },
  {
    "id": "dog08",
    "name": "Cookie",
    "url": "https://nookipedia.com/wiki/Cookie",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "cat05",
    "name": "Tangy",
    "url": "https://nookipedia.com/wiki/Tangy",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "squ17",
    "name": "Marshal",
    "url": "https://nookipedia.com/wiki/Marshal",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "der08",
    "name": "Diana",
    "url": "https://nookipedia.com/wiki/Diana",
    "skin_color": "ffebff",
    "text_color": "725661"
  },
  {
    "id": "rbt08",
    "name": "Genji",
    "url": "https://nookipedia.com/wiki/Genji",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "duk13",
    "name": "Ketchup",
    "url": "https://nookipedia.com/wiki/Ketchup",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "der09",
    "name": "Erik",
    "url": "https://nookipedia.com/wiki/Erik",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "hrs16",
    "name": "Reneigh",
    "url": "https://nookipedia.com/wiki/Reneigh",
    "skin_color": "76494e",
    "text_color": "fffce9"
  },
  {
    "id": "der00",
    "name": "Fauna",
    "url": "https://nookipedia.com/wiki/Fauna",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "squ14",
    "name": "Sylvana",
    "url": "https://nookipedia.com/wiki/Sylvana",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "squ02",
    "name": "Filbert",
    "url": "https://nookipedia.com/wiki/Filbert",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "wol06",
    "name": "Fang",
    "url": "https://nookipedia.com/wiki/Fang",
    "skin_color": "ddcdca",
    "text_color": "4b4496"
  },
  {
    "id": "cat18",
    "name": "Lolly",
    "url": "https://nookipedia.com/wiki/Lolly",
    "skin_color": "bff2ff",
    "text_color": "85a2af"
  },
  {
    "id": "cbr00",
    "name": "Bluebear",
    "url": "https://nookipedia.com/wiki/Bluebear",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "cat04",
    "name": "Kiki",
    "url": "https://nookipedia.com/wiki/Kiki",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "dog07",
    "name": "Daisy",
    "url": "https://nookipedia.com/wiki/Daisy",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "ocp01",
    "name": "Marina",
    "url": "https://nookipedia.com/wiki/Marina",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "ocp02",
    "name": "Zucker",
    "url": "https://nookipedia.com/wiki/Zucker",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "wol02",
    "name": "Wolfgang",
    "url": "https://nookipedia.com/wiki/Wolfgang",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "bea00",
    "name": "Teddy",
    "url": "https://nookipedia.com/wiki/Teddy",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "dog17",
    "name": "Cherry",
    "url": "https://nookipedia.com/wiki/Cherry",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "cat20",
    "name": "Rudy",
    "url": "https://nookipedia.com/wiki/Rudy",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "cat02",
    "name": "Rosie",
    "url": "https://nookipedia.com/wiki/Rosie",
    "skin_color": "7fa9ff",
    "text_color": "fffce9"
  },
  {
    "id": "cbr13",
    "name": "June",
    "url": "https://nookipedia.com/wiki/June_(villager)",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "cat06",
    "name": "Punchy",
    "url": "https://nookipedia.com/wiki/Punchy",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "rbt13",
    "name": "Chrissy",
    "url": "https://nookipedia.com/wiki/Chrissy",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "der01",
    "name": "Bam",
    "url": "https://nookipedia.com/wiki/Bam",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "cat01",
    "name": "Mitzi",
    "url": "https://nookipedia.com/wiki/Mitzi",
    "skin_color": "7fa9ff",
    "text_color": "fffce9"
  },
  {
    "id": "squ08",
    "name": "Static",
    "url": "https://nookipedia.com/wiki/Static",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "pig17",
    "name": "Agnes",
    "url": "https://nookipedia.com/wiki/Agnes",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "rbt09",
    "name": "Ruby",
    "url": "https://nookipedia.com/wiki/Ruby",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "shp13",
    "name": "Pietro",
    "url": "https://nookipedia.com/wiki/Pietro",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "cbr16",
    "name": "Barold",
    "url": "https://nookipedia.com/wiki/Barold",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e"
  },
  {
    "id": "cat03",
    "name": "Olivia",
    "url": "https://nookipedia.com/wiki/Olivia",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "cat10",
    "name": "Kid Cat",
    "url": "https://nookipedia.com/wiki/Kid_Cat",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "ocp00",
    "name": "Octavian",
    "url": "https://nookipedia.com/wiki/Octavian",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "dog03",
    "name": "Biskit",
    "url": "https://nookipedia.com/wiki/Biskit",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "cat12",
    "name": "Tabby",
    "url": "https://nookipedia.com/wiki/Tabby",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "cat17",
    "name": "Felicity",
    "url": "https://nookipedia.com/wiki/Felicity",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "elp10",
    "name": "Tia",
    "url": "https://nookipedia.com/wiki/Tia",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "pgn00",
    "name": "Aurora",
    "url": "https://nookipedia.com/wiki/Aurora",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "rhn07",
    "name": "Merengue",
    "url": "https://nookipedia.com/wiki/Merengue",
    "skin_color": "f2bdc7",
    "text_color": "634b4b"
  },
  {
    "id": "wol09",
    "name": "Skye",
    "url": "https://nookipedia.com/wiki/Skye",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "shp12",
    "name": "Muffy",
    "url": "https://nookipedia.com/wiki/Muffy",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "duk00",
    "name": "Bill",
    "url": "https://nookipedia.com/wiki/Bill",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "der04",
    "name": "Deirdre",
    "url": "https://nookipedia.com/wiki/Deirdre",
    "skin_color": "ddcdca",
    "text_color": "4b4496"
  },
  {
    "id": "pgn09",
    "name": "Wade",
    "url": "https://nookipedia.com/wiki/Wade",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "dog10",
    "name": "Bea",
    "url": "https://nookipedia.com/wiki/Bea",
    "skin_color": "a87850",
    "text_color": "fffce9"
  },
  {
    "id": "dog00",
    "name": "Goldie",
    "url": "https://nookipedia.com/wiki/Goldie",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "rbt01",
    "name": "Dotty",
    "url": "https://nookipedia.com/wiki/Dotty",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "bea15",
    "name": "Megan",
    "url": "https://nookipedia.com/wiki/Megan",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "rbt03",
    "name": "Snake",
    "url": "https://nookipedia.com/wiki/Snake",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "squ05",
    "name": "Agent S",
    "url": "https://nookipedia.com/wiki/Agent_S",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "shp03",
    "name": "Stella",
    "url": "https://nookipedia.com/wiki/Stella",
    "skin_color": "951d43",
    "text_color": "fffad4"
  },
  {
    "id": "flg00",
    "name": "Lily",
    "url": "https://nookipedia.com/wiki/Lily",
    "skin_color": "00d1bd",
    "text_color": "fffce9"
  },
  {
    "id": "ham06",
    "name": "Flurry",
    "url": "https://nookipedia.com/wiki/Flurry",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "elp01",
    "name": "Dizzy",
    "url": "https://nookipedia.com/wiki/Dizzy",
    "skin_color": "7fa9ff",
    "text_color": "fffce9"
  },
  {
    "id": "dog04",
    "name": "Bones",
    "url": "https://nookipedia.com/wiki/Bones",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "elp07",
    "name": "Ellie",
    "url": "https://nookipedia.com/wiki/Ellie",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "shp11",
    "name": "Frita",
    "url": "https://nookipedia.com/wiki/Frita",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "rbt00",
    "name": "Bunnie",
    "url": "https://nookipedia.com/wiki/Bunnie",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "cat21",
    "name": "Katt",
    "url": "https://nookipedia.com/wiki/Katt",
    "skin_color": "a87850",
    "text_color": "fffce9"
  },
  {
    "id": "hrs04",
    "name": "Roscoe",
    "url": "https://nookipedia.com/wiki/Roscoe",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "der06",
    "name": "Fuchsia",
    "url": "https://nookipedia.com/wiki/Fuchsia",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "ost09",
    "name": "Flora",
    "url": "https://nookipedia.com/wiki/Flora",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "kal02",
    "name": "Melba",
    "url": "https://nookipedia.com/wiki/Melba",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "goa00",
    "name": "Chevre",
    "url": "https://nookipedia.com/wiki/Chevre",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "crd08",
    "name": "Drago",
    "url": "https://nookipedia.com/wiki/Drago",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "pig13",
    "name": "Gala",
    "url": "https://nookipedia.com/wiki/Gala",
    "skin_color": "feeae7",
    "text_color": "97858e"
  },
  {
    "id": "rbt12",
    "name": "Francine",
    "url": "https://nookipedia.com/wiki/Francine",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "pgn14",
    "name": "Sprinkle",
    "url": "https://nookipedia.com/wiki/Sprinkle",
    "skin_color": "00d1bd",
    "text_color": "fffce9"
  },
  {
    "id": "mus02",
    "name": "Bella",
    "url": "https://nookipedia.com/wiki/Bella",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "der02",
    "name": "Zell",
    "url": "https://nookipedia.com/wiki/Zell",
    "skin_color": "4c3317",
    "text_color": "fffce9"
  },
  {
    "id": "wol08",
    "name": "Vivian",
    "url": "https://nookipedia.com/wiki/Vivian",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "wol05",
    "name": "Freya",
    "url": "https://nookipedia.com/wiki/Freya",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "squ00",
    "name": "Peanut",
    "url": "https://nookipedia.com/wiki/Peanut",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "goa08",
    "name": "Pashmina",
    "url": "https://nookipedia.com/wiki/Pashmina",
    "skin_color": "e2856b",
    "text_color": "fffce9"
  },
  {
    "id": "ost01",
    "name": "Gladys",
    "url": "https://nookipedia.com/wiki/Gladys",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "duk01",
    "name": "Joey",
    "url": "https://nookipedia.com/wiki/Joey",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "cat08",
    "name": "Moe",
    "url": "https://nookipedia.com/wiki/Moe",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "squ01",
    "name": "Blaire",
    "url": "https://nookipedia.com/wiki/Blaire",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "hrs02",
    "name": "Savannah",
    "url": "https://nookipedia.com/wiki/Savannah",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "wol10",
    "name": "Kyle",
    "url": "https://nookipedia.com/wiki/Kyle",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "cbr10",
    "name": "Cheri",
    "url": "https://nookipedia.com/wiki/Cheri",
    "skin_color": "db6161",
    "text_color": "fffce9"
  },
  {
    "id": "rbt16",
    "name": "Carmen",
    "url": "https://nookipedia.com/wiki/Carmen",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "bea07",
    "name": "Tutu",
    "url": "https://nookipedia.com/wiki/Tutu",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "flg01",
    "name": "Ribbot",
    "url": "https://nookipedia.com/wiki/Ribbot",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e"
  },
  {
    "id": "dog15",
    "name": "Marcel",
    "url": "https://nookipedia.com/wiki/Marcel",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "dog18",
    "name": "Shep",
    "url": "https://nookipedia.com/wiki/Shep",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "kal09",
    "name": "Lyman",
    "url": "https://nookipedia.com/wiki/Lyman",
    "skin_color": "a8e989",
    "text_color": "878e86"
  },
  {
    "id": "wol00",
    "name": "Chief",
    "url": "https://nookipedia.com/wiki/Chief",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "ost10",
    "name": "Phoebe",
    "url": "https://nookipedia.com/wiki/Phoebe",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "cat07",
    "name": "Purrl",
    "url": "https://nookipedia.com/wiki/Purrl",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "kal05",
    "name": "Ozzie",
    "url": "https://nookipedia.com/wiki/Ozzie",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e"
  },
  {
    "id": "ost05",
    "name": "Julia",
    "url": "https://nookipedia.com/wiki/Julia",
    "skin_color": "0ca54a",
    "text_color": "fffce9"
  },
  {
    "id": "squ13",
    "name": "Tasha",
    "url": "https://nookipedia.com/wiki/Tasha",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "crd07",
    "name": "Gayle",
    "url": "https://nookipedia.com/wiki/Gayle",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "wol01",
    "name": "Lobo",
    "url": "https://nookipedia.com/wiki/Lobo",
    "skin_color": "7352e8",
    "text_color": "fffce9"
  },
  {
    "id": "goa01",
    "name": "Nan",
    "url": "https://nookipedia.com/wiki/Nan",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "pgn02",
    "name": "Cube",
    "url": "https://nookipedia.com/wiki/Cube",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "flg19",
    "name": "Henry",
    "url": "https://nookipedia.com/wiki/Henry",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "kal01",
    "name": "Alice",
    "url": "https://nookipedia.com/wiki/Alice",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "squ06",
    "name": "Caroline",
    "url": "https://nookipedia.com/wiki/Caroline",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "crd00",
    "name": "Alfonso",
    "url": "https://nookipedia.com/wiki/Alfonso",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "mus12",
    "name": "Broccolo",
    "url": "https://nookipedia.com/wiki/Broccolo",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "duk10",
    "name": "Scoot",
    "url": "https://nookipedia.com/wiki/Scoot",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "elp12",
    "name": "Cyd",
    "url": "https://nookipedia.com/wiki/Cyd",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "cbr15",
    "name": "Chester",
    "url": "https://nookipedia.com/wiki/Chester",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "ham05",
    "name": "Clay",
    "url": "https://nookipedia.com/wiki/Clay",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "rbt18",
    "name": "Cole",
    "url": "https://nookipedia.com/wiki/Cole",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "bea09",
    "name": "Grizzly",
    "url": "https://nookipedia.com/wiki/Grizzly",
    "skin_color": "7c6559",
    "text_color": "eac113"
  },
  {
    "id": "brd02",
    "name": "Anchovy",
    "url": "https://nookipedia.com/wiki/Anchovy",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "flg15",
    "name": "Raddle",
    "url": "https://nookipedia.com/wiki/Raddle",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "tig06",
    "name": "Bianca",
    "url": "https://nookipedia.com/wiki/Bianca",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "shp09",
    "name": "Wendy",
    "url": "https://nookipedia.com/wiki/Wendy",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "duk02",
    "name": "Pate",
    "url": "https://nookipedia.com/wiki/Pate",
    "skin_color": "8bcdea",
    "text_color": "fffad4"
  },
  {
    "id": "hrs12",
    "name": "Papi",
    "url": "https://nookipedia.com/wiki/Papi",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "rbt07",
    "name": "Tiffany",
    "url": "https://nookipedia.com/wiki/Tiffany",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "pgn03",
    "name": "Hopper",
    "url": "https://nookipedia.com/wiki/Hopper",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "rbt14",
    "name": "Hopkins",
    "url": "https://nookipedia.com/wiki/Hopkins",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "der03",
    "name": "Bruce",
    "url": "https://nookipedia.com/wiki/Bruce",
    "skin_color": "459aba",
    "text_color": "fffce9"
  },
  {
    "id": "elp04",
    "name": "Margie",
    "url": "https://nookipedia.com/wiki/Margie",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "rbt19",
    "name": "Mira",
    "url": "https://nookipedia.com/wiki/Mira",
    "skin_color": "fff80d",
    "text_color": "9b8986"
  },
  {
    "id": "cbr02",
    "name": "Poncho",
    "url": "https://nookipedia.com/wiki/Poncho",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "ham01",
    "name": "Apple",
    "url": "https://nookipedia.com/wiki/Apple",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "duk05",
    "name": "Pompom",
    "url": "https://nookipedia.com/wiki/Pompom",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "tig00",
    "name": "Rolf",
    "url": "https://nookipedia.com/wiki/Rolf",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "kal08",
    "name": "Canberra",
    "url": "https://nookipedia.com/wiki/Canberra",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "pbr07",
    "name": "Sterling",
    "url": "https://nookipedia.com/wiki/Sterling",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e"
  },
  {
    "id": "squ04",
    "name": "Nibbles",
    "url": "https://nookipedia.com/wiki/Nibbles",
    "skin_color": "00d1bd",
    "text_color": "fffce9"
  },
  {
    "id": "kgr08",
    "name": "Walt",
    "url": "https://nookipedia.com/wiki/Walt",
    "skin_color": "acc8cf",
    "text_color": "498992"
  },
  {
    "id": "squ18",
    "name": "Hazel",
    "url": "https://nookipedia.com/wiki/Hazel",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "ham00",
    "name": "Hamlet",
    "url": "https://nookipedia.com/wiki/Hamlet",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "rbt17",
    "name": "Bonbon",
    "url": "https://nookipedia.com/wiki/Bonbon",
    "skin_color": "7c6559",
    "text_color": "eac113"
  },
  {
    "id": "dog06",
    "name": "Walker",
    "url": "https://nookipedia.com/wiki/Walker",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "der05",
    "name": "Lopez",
    "url": "https://nookipedia.com/wiki/Lopez",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "dog09",
    "name": "Maddie",
    "url": "https://nookipedia.com/wiki/Maddie",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "dog01",
    "name": "Butch",
    "url": "https://nookipedia.com/wiki/Butch",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "flg06",
    "name": "Puddles",
    "url": "https://nookipedia.com/wiki/Puddles",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "mnk01",
    "name": "Nana",
    "url": "https://nookipedia.com/wiki/Nana",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "ost08",
    "name": "Blanche",
    "url": "https://nookipedia.com/wiki/Blanche",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "cat15",
    "name": "Tom",
    "url": "https://nookipedia.com/wiki/Tom",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "mus05",
    "name": "Rod",
    "url": "https://nookipedia.com/wiki/Rod",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "cbr09",
    "name": "Olive",
    "url": "https://nookipedia.com/wiki/Olive",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e"
  },
  {
    "id": "rhn04",
    "name": "Hornsby",
    "url": "https://nookipedia.com/wiki/Hornsby",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "pgn10",
    "name": "Boomer",
    "url": "https://nookipedia.com/wiki/Boomer",
    "skin_color": "798040",
    "text_color": "fffad4"
  },
  {
    "id": "duk07",
    "name": "Freckles",
    "url": "https://nookipedia.com/wiki/Freckles",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "cat13",
    "name": "Stinky",
    "url": "https://nookipedia.com/wiki/Stinky",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "squ03",
    "name": "Pecan",
    "url": "https://nookipedia.com/wiki/Pecan",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "dog16",
    "name": "Benjamin",
    "url": "https://nookipedia.com/wiki/Benjamin",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "goa07",
    "name": "Kidd",
    "url": "https://nookipedia.com/wiki/Kidd",
    "skin_color": "d9d9ff",
    "text_color": "4f5d72"
  },
  {
    "id": "flg07",
    "name": "Jeremiah",
    "url": "https://nookipedia.com/wiki/Jeremiah",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "cbr07",
    "name": "Murphy",
    "url": "https://nookipedia.com/wiki/Murphy",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "chn13",
    "name": "Ken",
    "url": "https://nookipedia.com/wiki/Ken",
    "skin_color": "6b75ce",
    "text_color": "9ae8df"
  },
  {
    "id": "chn02",
    "name": "Egbert",
    "url": "https://nookipedia.com/wiki/Egbert",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "duk11",
    "name": "Weber",
    "url": "https://nookipedia.com/wiki/Weber",
    "skin_color": "a87850",
    "text_color": "fffce9"
  },
  {
    "id": "pig03",
    "name": "Hugh",
    "url": "https://nookipedia.com/wiki/Hugh",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "goa02",
    "name": "Billy",
    "url": "https://nookipedia.com/wiki/Billy",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "kal03",
    "name": "Sydney",
    "url": "https://nookipedia.com/wiki/Sydney",
    "skin_color": "7352e8",
    "text_color": "fffce9"
  },
  {
    "id": "pbr09",
    "name": "Celia",
    "url": "https://nookipedia.com/wiki/Celia",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "dog05",
    "name": "Portia",
    "url": "https://nookipedia.com/wiki/Portia",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "rbt04",
    "name": "Gaston",
    "url": "https://nookipedia.com/wiki/Gaston",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "cbr17",
    "name": "Tammy",
    "url": "https://nookipedia.com/wiki/Tammy",
    "skin_color": "fff80d",
    "text_color": "9b8986"
  },
  {
    "id": "pgn11",
    "name": "Iggly",
    "url": "https://nookipedia.com/wiki/Iggly",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "dog14",
    "name": "Mac",
    "url": "https://nookipedia.com/wiki/Mac",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "cbr04",
    "name": "Kody",
    "url": "https://nookipedia.com/wiki/Kody",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "kal04",
    "name": "Gonzo",
    "url": "https://nookipedia.com/wiki/Gonzo",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e"
  },
  {
    "id": "squ09",
    "name": "Mint",
    "url": "https://nookipedia.com/wiki/Mint",
    "skin_color": "87e0a9",
    "text_color": "219479"
  },
  {
    "id": "brd06",
    "name": "Admiral",
    "url": "https://nookipedia.com/wiki/Admiral",
    "skin_color": "0ca54a",
    "text_color": "fffce9"
  },
  {
    "id": "hip04",
    "name": "Biff",
    "url": "https://nookipedia.com/wiki/Biff",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "rhn00",
    "name": "Tank",
    "url": "https://nookipedia.com/wiki/Tank",
    "skin_color": "8bcdea",
    "text_color": "fffad4"
  },
  {
    "id": "shp07",
    "name": "Willow",
    "url": "https://nookipedia.com/wiki/Willow",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "bul00",
    "name": "Angus",
    "url": "https://nookipedia.com/wiki/Angus",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "bea14",
    "name": "Klaus",
    "url": "https://nookipedia.com/wiki/Klaus",
    "skin_color": "acc8cf",
    "text_color": "498992"
  },
  {
    "id": "hrs11",
    "name": "Colton",
    "url": "https://nookipedia.com/wiki/Colton",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "pgn12",
    "name": "Tex",
    "url": "https://nookipedia.com/wiki/Tex",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "pbr05",
    "name": "Avery",
    "url": "https://nookipedia.com/wiki/Avery",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "flg05",
    "name": "Wart Jr.",
    "url": "https://nookipedia.com/wiki/Wart_Jr.",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "mnk02",
    "name": "Simon",
    "url": "https://nookipedia.com/wiki/Simon",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "ant06",
    "name": "Snooty",
    "url": "https://nookipedia.com/wiki/Snooty_(villager)",
    "skin_color": "f2bdc7",
    "text_color": "634b4b"
  },
  {
    "id": "shp14",
    "name": "Étoile",
    "url": "https://nookipedia.com/wiki/Étoile",
    "skin_color": "b99fff",
    "text_color": "ffd7eb"
  },
  {
    "id": "mnk03",
    "name": "Tammi",
    "url": "https://nookipedia.com/wiki/Tammi",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "cbr03",
    "name": "Pudge",
    "url": "https://nookipedia.com/wiki/Pudge",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "squ11",
    "name": "Cally",
    "url": "https://nookipedia.com/wiki/Cally",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "ant01",
    "name": "Antonio",
    "url": "https://nookipedia.com/wiki/Antonio",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "rbt11",
    "name": "Claude",
    "url": "https://nookipedia.com/wiki/Claude",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "ant03",
    "name": "Anabelle",
    "url": "https://nookipedia.com/wiki/Anabelle",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "cat11",
    "name": "Monique",
    "url": "https://nookipedia.com/wiki/Monique",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "flg09",
    "name": "Tad",
    "url": "https://nookipedia.com/wiki/Tad",
    "skin_color": "76b788",
    "text_color": "fffce9"
  },
  {
    "id": "flg17",
    "name": "Croque",
    "url": "https://nookipedia.com/wiki/Croque",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "bea01",
    "name": "Pinky",
    "url": "https://nookipedia.com/wiki/Pinky",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "ost03",
    "name": "Sprocket",
    "url": "https://nookipedia.com/wiki/Sprocket",
    "skin_color": "0ca54a",
    "text_color": "fffce9"
  },
  {
    "id": "duk09",
    "name": "Drake",
    "url": "https://nookipedia.com/wiki/Drake",
    "skin_color": "459aba",
    "text_color": "fffce9"
  },
  {
    "id": "brd00",
    "name": "Jay",
    "url": "https://nookipedia.com/wiki/Jay",
    "skin_color": "6b75ce",
    "text_color": "9ae8df"
  },
  {
    "id": "flg03",
    "name": "Camofrog",
    "url": "https://nookipedia.com/wiki/Camofrog",
    "skin_color": "76b788",
    "text_color": "fffce9"
  },
  {
    "id": "shp02",
    "name": "Eunice",
    "url": "https://nookipedia.com/wiki/Eunice",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "chn01",
    "name": "Benedict",
    "url": "https://nookipedia.com/wiki/Benedict",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "bul01",
    "name": "Rodeo",
    "url": "https://nookipedia.com/wiki/Rodeo",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "shp00",
    "name": "Vesta",
    "url": "https://nookipedia.com/wiki/Vesta",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "flg12",
    "name": "Prince",
    "url": "https://nookipedia.com/wiki/Prince",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "mus18",
    "name": "Chadder",
    "url": "https://nookipedia.com/wiki/Chadder",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "tig02",
    "name": "Tybalt",
    "url": "https://nookipedia.com/wiki/Tybalt",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "pig08",
    "name": "Cobb",
    "url": "https://nookipedia.com/wiki/Cobb",
    "skin_color": "a8e989",
    "text_color": "878e86"
  },
  {
    "id": "cat14",
    "name": "Kitty",
    "url": "https://nookipedia.com/wiki/Kitty",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "flg10",
    "name": "Cousteau",
    "url": "https://nookipedia.com/wiki/Cousteau",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "duk17",
    "name": "Quillson",
    "url": "https://nookipedia.com/wiki/Quillson",
    "skin_color": "76b788",
    "text_color": "fffce9"
  },
  {
    "id": "kal10",
    "name": "Eugene",
    "url": "https://nookipedia.com/wiki/Eugene",
    "skin_color": "4c3317",
    "text_color": "fffce9"
  },
  {
    "id": "ost06",
    "name": "Cranston",
    "url": "https://nookipedia.com/wiki/Cranston",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "rbt15",
    "name": "O'Hare",
    "url": "https://nookipedia.com/wiki/O'Hare",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "cow01",
    "name": "Tipper",
    "url": "https://nookipedia.com/wiki/Tipper",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "brd16",
    "name": "Jacques",
    "url": "https://nookipedia.com/wiki/Jacques",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "rhn08",
    "name": "Renée",
    "url": "https://nookipedia.com/wiki/Renée",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "shp10",
    "name": "Timbra",
    "url": "https://nookipedia.com/wiki/Timbra",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "duk12",
    "name": "Miranda",
    "url": "https://nookipedia.com/wiki/Miranda",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "mnk07",
    "name": "Shari",
    "url": "https://nookipedia.com/wiki/Shari",
    "skin_color": "bfbfbf",
    "text_color": "5e5e5e"
  },
  {
    "id": "crd06",
    "name": "Sly",
    "url": "https://nookipedia.com/wiki/Sly",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "squ10",
    "name": "Ricky",
    "url": "https://nookipedia.com/wiki/Ricky",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "mnk08",
    "name": "Deli",
    "url": "https://nookipedia.com/wiki/Deli",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "pbr01",
    "name": "Amelia",
    "url": "https://nookipedia.com/wiki/Amelia",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "hrs10",
    "name": "Clyde",
    "url": "https://nookipedia.com/wiki/Clyde",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "gor02",
    "name": "Boone",
    "url": "https://nookipedia.com/wiki/Boone",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "ost07",
    "name": "Phil",
    "url": "https://nookipedia.com/wiki/Phil",
    "skin_color": "7352e8",
    "text_color": "fffce9"
  },
  {
    "id": "hrs07",
    "name": "Cleo",
    "url": "https://nookipedia.com/wiki/Cleo",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "bul03",
    "name": "Stu",
    "url": "https://nookipedia.com/wiki/Stu",
    "skin_color": "6b75ce",
    "text_color": "9ae8df"
  },
  {
    "id": "cbr06",
    "name": "Vladimir",
    "url": "https://nookipedia.com/wiki/Vladimir",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "bea08",
    "name": "Ursala",
    "url": "https://nookipedia.com/wiki/Ursala",
    "skin_color": "f2bdc7",
    "text_color": "634b4b"
  },
  {
    "id": "ham07",
    "name": "Hamphrey",
    "url": "https://nookipedia.com/wiki/Hamphrey",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "lon01",
    "name": "Elvis",
    "url": "https://nookipedia.com/wiki/Elvis",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "elp00",
    "name": "Opal",
    "url": "https://nookipedia.com/wiki/Opal",
    "skin_color": "87e0a9",
    "text_color": "219479"
  },
  {
    "id": "tig03",
    "name": "Bangle",
    "url": "https://nookipedia.com/wiki/Bangle",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "shp08",
    "name": "Curlos",
    "url": "https://nookipedia.com/wiki/Curlos",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "brd04",
    "name": "Jitters",
    "url": "https://nookipedia.com/wiki/Jitters",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "mnk06",
    "name": "Flip",
    "url": "https://nookipedia.com/wiki/Flip",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "brd11",
    "name": "Jacob",
    "url": "https://nookipedia.com/wiki/Jacob",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "duk04",
    "name": "Deena",
    "url": "https://nookipedia.com/wiki/Deena",
    "skin_color": "798040",
    "text_color": "fffad4"
  },
  {
    "id": "rbt05",
    "name": "Gabi",
    "url": "https://nookipedia.com/wiki/Gabi",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "pgn06",
    "name": "Puck",
    "url": "https://nookipedia.com/wiki/Puck",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "squ07",
    "name": "Sally",
    "url": "https://nookipedia.com/wiki/Sally",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "chn05",
    "name": "Ava",
    "url": "https://nookipedia.com/wiki/Ava",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "brd03",
    "name": "Twiggy",
    "url": "https://nookipedia.com/wiki/Twiggy",
    "skin_color": "fff80d",
    "text_color": "9b8986"
  },
  {
    "id": "brd08",
    "name": "Midge",
    "url": "https://nookipedia.com/wiki/Midge",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "elp05",
    "name": "Paolo",
    "url": "https://nookipedia.com/wiki/Paolo",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "squ16",
    "name": "Sheldon",
    "url": "https://nookipedia.com/wiki/Sheldon",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "brd18",
    "name": "Sparro",
    "url": "https://nookipedia.com/wiki/Sparro",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "bea05",
    "name": "Nate",
    "url": "https://nookipedia.com/wiki/Nate",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "pgn04",
    "name": "Friga",
    "url": "https://nookipedia.com/wiki/Friga",
    "skin_color": "f2bdc7",
    "text_color": "634b4b"
  },
  {
    "id": "gor01",
    "name": "Peewee",
    "url": "https://nookipedia.com/wiki/Peewee",
    "skin_color": "7fa9ff",
    "text_color": "fffce9"
  },
  {
    "id": "pig09",
    "name": "Boris",
    "url": "https://nookipedia.com/wiki/Boris",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "pgn13",
    "name": "Flo",
    "url": "https://nookipedia.com/wiki/Flo",
    "skin_color": "6b75ce",
    "text_color": "9ae8df"
  },
  {
    "id": "pbr02",
    "name": "Pierce",
    "url": "https://nookipedia.com/wiki/Pierce",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "mus03",
    "name": "Bree",
    "url": "https://nookipedia.com/wiki/Bree",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "cbr18",
    "name": "Marty",
    "url": "https://nookipedia.com/wiki/Marty",
    "skin_color": "f8e880",
    "text_color": "9a543a"
  },
  {
    "id": "kgr10",
    "name": "Marcie",
    "url": "https://nookipedia.com/wiki/Marcie",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "hip09",
    "name": "Hippeux",
    "url": "https://nookipedia.com/wiki/Hippeux",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "elp09",
    "name": "Tucker",
    "url": "https://nookipedia.com/wiki/Tucker",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "ham03",
    "name": "Rodney",
    "url": "https://nookipedia.com/wiki/Rodney",
    "skin_color": "459aba",
    "text_color": "fffce9"
  },
  {
    "id": "duk08",
    "name": "Derwin",
    "url": "https://nookipedia.com/wiki/Derwin",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "brd01",
    "name": "Robin",
    "url": "https://nookipedia.com/wiki/Robin",
    "skin_color": "6b75ce",
    "text_color": "9ae8df"
  },
  {
    "id": "flg16",
    "name": "Gigi",
    "url": "https://nookipedia.com/wiki/Gigi",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "bea13",
    "name": "Beardo",
    "url": "https://nookipedia.com/wiki/Beardo",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "hrs00",
    "name": "Buck",
    "url": "https://nookipedia.com/wiki/Buck",
    "skin_color": "798040",
    "text_color": "fffad4"
  },
  {
    "id": "duk06",
    "name": "Mallary",
    "url": "https://nookipedia.com/wiki/Mallary",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "hrs01",
    "name": "Victoria",
    "url": "https://nookipedia.com/wiki/Victoria",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "crd02",
    "name": "Boots",
    "url": "https://nookipedia.com/wiki/Boots",
    "skin_color": "0ca54a",
    "text_color": "fffce9"
  },
  {
    "id": "bea06",
    "name": "Groucho",
    "url": "https://nookipedia.com/wiki/Groucho",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "lon02",
    "name": "Rex",
    "url": "https://nookipedia.com/wiki/Rex",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "flg13",
    "name": "Jambette",
    "url": "https://nookipedia.com/wiki/Jambette",
    "skin_color": "0ca54a",
    "text_color": "fffce9"
  },
  {
    "id": "brd05",
    "name": "Piper",
    "url": "https://nookipedia.com/wiki/Piper",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "ham02",
    "name": "Graham",
    "url": "https://nookipedia.com/wiki/Graham",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "chn11",
    "name": "Knox",
    "url": "https://nookipedia.com/wiki/Knox",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "mus09",
    "name": "Rizzo",
    "url": "https://nookipedia.com/wiki/Rizzo",
    "skin_color": "8bcdea",
    "text_color": "fffad4"
  },
  {
    "id": "kgr01",
    "name": "Mathilda",
    "url": "https://nookipedia.com/wiki/Mathilda",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "tig01",
    "name": "Rowan",
    "url": "https://nookipedia.com/wiki/Rowan",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "hrs05",
    "name": "Winnie",
    "url": "https://nookipedia.com/wiki/Winnie",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "kgr00",
    "name": "Kitt",
    "url": "https://nookipedia.com/wiki/Kitt",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "cow06",
    "name": "Norma",
    "url": "https://nookipedia.com/wiki/Norma",
    "skin_color": "f2bdc7",
    "text_color": "634b4b"
  },
  {
    "id": "hip03",
    "name": "Bertha",
    "url": "https://nookipedia.com/wiki/Bertha",
    "skin_color": "00d1bd",
    "text_color": "fffce9"
  },
  {
    "id": "flg18",
    "name": "Diva",
    "url": "https://nookipedia.com/wiki/Diva",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "brd17",
    "name": "Peck",
    "url": "https://nookipedia.com/wiki/Peck",
    "skin_color": "4c3317",
    "text_color": "fffce9"
  },
  {
    "id": "bea02",
    "name": "Curt",
    "url": "https://nookipedia.com/wiki/Curt",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "flg02",
    "name": "Frobert",
    "url": "https://nookipedia.com/wiki/Frobert",
    "skin_color": "87e0a9",
    "text_color": "219479"
  },
  {
    "id": "pig11",
    "name": "Peggy",
    "url": "https://nookipedia.com/wiki/Peggy",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "hrs03",
    "name": "Elmer",
    "url": "https://nookipedia.com/wiki/Elmer",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "bul05",
    "name": "T-Bone",
    "url": "https://nookipedia.com/wiki/T-Bone",
    "skin_color": "acc8cf",
    "text_color": "498992"
  },
  {
    "id": "chn10",
    "name": "Plucky",
    "url": "https://nookipedia.com/wiki/Plucky",
    "skin_color": "7c6559",
    "text_color": "eac113"
  },
  {
    "id": "bea03",
    "name": "Chow",
    "url": "https://nookipedia.com/wiki/Chow",
    "skin_color": "f2bdc7",
    "text_color": "634b4b"
  },
  {
    "id": "elp06",
    "name": "Axel",
    "url": "https://nookipedia.com/wiki/Axel",
    "skin_color": "459aba",
    "text_color": "fffce9"
  },
  {
    "id": "lon06",
    "name": "Mott",
    "url": "https://nookipedia.com/wiki/Mott",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "elp02",
    "name": "Big Top",
    "url": "https://nookipedia.com/wiki/Big_Top",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "hip00",
    "name": "Rocco",
    "url": "https://nookipedia.com/wiki/Rocco",
    "skin_color": "87e0a9",
    "text_color": "219479"
  },
  {
    "id": "flg04",
    "name": "Drift",
    "url": "https://nookipedia.com/wiki/Drift",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "pbr08",
    "name": "Keaton",
    "url": "https://nookipedia.com/wiki/Keaton",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "crd04",
    "name": "Del",
    "url": "https://nookipedia.com/wiki/Del",
    "skin_color": "6b75ce",
    "text_color": "9ae8df"
  },
  {
    "id": "chn12",
    "name": "Broffina",
    "url": "https://nookipedia.com/wiki/Broffina",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "duk03",
    "name": "Maelle",
    "url": "https://nookipedia.com/wiki/Maelle",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "elp03",
    "name": "Eloise",
    "url": "https://nookipedia.com/wiki/Eloise",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "gor09",
    "name": "Rocket",
    "url": "https://nookipedia.com/wiki/Rocket",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "bea12",
    "name": "Charlise",
    "url": "https://nookipedia.com/wiki/Charlise",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "gor05",
    "name": "Boyd",
    "url": "https://nookipedia.com/wiki/Boyd",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "lon08",
    "name": "Lionel",
    "url": "https://nookipedia.com/wiki/Lionel",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "hrs09",
    "name": "Annalise",
    "url": "https://nookipedia.com/wiki/Annalise",
    "skin_color": "7c6559",
    "text_color": "eac113"
  },
  {
    "id": "chn09",
    "name": "Becky",
    "url": "https://nookipedia.com/wiki/Becky",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "elp11",
    "name": "Chai",
    "url": "https://nookipedia.com/wiki/Chai",
    "skin_color": "cefdff",
    "text_color": "52b8ec"
  },
  {
    "id": "gor10",
    "name": "Hans",
    "url": "https://nookipedia.com/wiki/Hans",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "kgr09",
    "name": "Rooney",
    "url": "https://nookipedia.com/wiki/Rooney",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "rhn01",
    "name": "Rhonda",
    "url": "https://nookipedia.com/wiki/Rhonda",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "cow00",
    "name": "Patty",
    "url": "https://nookipedia.com/wiki/Patty",
    "skin_color": "7a2500",
    "text_color": "fffce9"
  },
  {
    "id": "lon00",
    "name": "Bud",
    "url": "https://nookipedia.com/wiki/Bud",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "mus17",
    "name": "Penelope",
    "url": "https://nookipedia.com/wiki/Penelope",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "bul08",
    "name": "Vic",
    "url": "https://nookipedia.com/wiki/Vic",
    "skin_color": "c0ab72",
    "text_color": "fffce9"
  },
  {
    "id": "hrs08",
    "name": "Peaches",
    "url": "https://nookipedia.com/wiki/Peaches",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "mus16",
    "name": "Greta",
    "url": "https://nookipedia.com/wiki/Greta",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "mnk05",
    "name": "Elise",
    "url": "https://nookipedia.com/wiki/Elise",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "ant08",
    "name": "Annalisa",
    "url": "https://nookipedia.com/wiki/Annalisa",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "shp04",
    "name": "Cashmere",
    "url": "https://nookipedia.com/wiki/Cashmere",
    "skin_color": "bff2ff",
    "text_color": "85a2af"
  },
  {
    "id": "chn00",
    "name": "Goose",
    "url": "https://nookipedia.com/wiki/Goose",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "ant09",
    "name": "Olaf",
    "url": "https://nookipedia.com/wiki/Olaf",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "ost02",
    "name": "Sandy",
    "url": "https://nookipedia.com/wiki/Sandy",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "rhn02",
    "name": "Spike",
    "url": "https://nookipedia.com/wiki/Spike",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "ant00",
    "name": "Cyrano",
    "url": "https://nookipedia.com/wiki/Cyrano",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "pgn05",
    "name": "Gwen",
    "url": "https://nookipedia.com/wiki/Gwen",
    "skin_color": "7352e8",
    "text_color": "fffce9"
  },
  {
    "id": "kgr05",
    "name": "Astrid",
    "url": "https://nookipedia.com/wiki/Astrid",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "bea11",
    "name": "Ike",
    "url": "https://nookipedia.com/wiki/Ike",
    "skin_color": "4c3317",
    "text_color": "fffce9"
  },
  {
    "id": "rbt10",
    "name": "Doc",
    "url": "https://nookipedia.com/wiki/Doc",
    "skin_color": "0961f6",
    "text_color": "fffce9"
  },
  {
    "id": "pig05",
    "name": "Spork",
    "url": "https://nookipedia.com/wiki/Spork",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "mus00",
    "name": "Dora",
    "url": "https://nookipedia.com/wiki/Dora",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "flg11",
    "name": "Huck",
    "url": "https://nookipedia.com/wiki/Huck",
    "skin_color": "515151",
    "text_color": "fffce9"
  },
  {
    "id": "hip02",
    "name": "Bubbles",
    "url": "https://nookipedia.com/wiki/Bubbles",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "gor08",
    "name": "Al",
    "url": "https://nookipedia.com/wiki/Al",
    "skin_color": "798040",
    "text_color": "fffad4"
  },
  {
    "id": "pig04",
    "name": "Lucy",
    "url": "https://nookipedia.com/wiki/Lucy",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "hip05",
    "name": "Bitty",
    "url": "https://nookipedia.com/wiki/Bitty",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "lon04",
    "name": "Leopold",
    "url": "https://nookipedia.com/wiki/Leopold",
    "skin_color": "e4b887",
    "text_color": "fffce9"
  },
  {
    "id": "duk15",
    "name": "Gloria",
    "url": "https://nookipedia.com/wiki/Gloria",
    "skin_color": "ffffff",
    "text_color": "848484"
  },
  {
    "id": "pbr03",
    "name": "Buzz",
    "url": "https://nookipedia.com/wiki/Buzz",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "mus01",
    "name": "Limberg",
    "url": "https://nookipedia.com/wiki/Limberg",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "pig00",
    "name": "Curly",
    "url": "https://nookipedia.com/wiki/Curly",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "pig10",
    "name": "Maggie",
    "url": "https://nookipedia.com/wiki/Maggie",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "kal00",
    "name": "Yuka",
    "url": "https://nookipedia.com/wiki/Yuka",
    "skin_color": "194c89",
    "text_color": "fffad4"
  },
  {
    "id": "lon07",
    "name": "Rory",
    "url": "https://nookipedia.com/wiki/Rory",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "gor07",
    "name": "Violet",
    "url": "https://nookipedia.com/wiki/Violet",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "mus10",
    "name": "Anicotti",
    "url": "https://nookipedia.com/wiki/Anicotti",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "shp01",
    "name": "Baabara",
    "url": "https://nookipedia.com/wiki/Baabara",
    "skin_color": "8bcdea",
    "text_color": "fffad4"
  },
  {
    "id": "tig05",
    "name": "Claudia",
    "url": "https://nookipedia.com/wiki/Claudia",
    "skin_color": "ec7efc",
    "text_color": "fffce9"
  },
  {
    "id": "hrs06",
    "name": "Ed",
    "url": "https://nookipedia.com/wiki/Ed",
    "skin_color": "55cfff",
    "text_color": "fffce9"
  },
  {
    "id": "mus14",
    "name": "Moose",
    "url": "https://nookipedia.com/wiki/Moose",
    "skin_color": "7fa9ff",
    "text_color": "fffce9"
  },
  {
    "id": "bul07",
    "name": "Coach",
    "url": "https://nookipedia.com/wiki/Coach",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "rbt06",
    "name": "Pippy",
    "url": "https://nookipedia.com/wiki/Pippy",
    "skin_color": "fff98f",
    "text_color": "879b96"
  },
  {
    "id": "ant02",
    "name": "Pango",
    "url": "https://nookipedia.com/wiki/Pango",
    "skin_color": "00d1bd",
    "text_color": "fffce9"
  },
  {
    "id": "bea10",
    "name": "Paula",
    "url": "https://nookipedia.com/wiki/Paula",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "tig04",
    "name": "Leonardo",
    "url": "https://nookipedia.com/wiki/Leonardo",
    "skin_color": "ffd00d",
    "text_color": "9b553a"
  },
  {
    "id": "kgr02",
    "name": "Carrie",
    "url": "https://nookipedia.com/wiki/Carrie",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "gor04",
    "name": "Louie",
    "url": "https://nookipedia.com/wiki/Louie",
    "skin_color": "d86808",
    "text_color": "fffce9"
  },
  {
    "id": "mus08",
    "name": "Candi",
    "url": "https://nookipedia.com/wiki/Candi",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "pig16",
    "name": "Pancetti",
    "url": "https://nookipedia.com/wiki/Pancetti",
    "skin_color": "e2856b",
    "text_color": "fffce9"
  },
  {
    "id": "pig02",
    "name": "Rasher",
    "url": "https://nookipedia.com/wiki/Rasher",
    "skin_color": "951d43",
    "text_color": "fffad4"
  },
  {
    "id": "goa04",
    "name": "Gruff",
    "url": "https://nookipedia.com/wiki/Gruff",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "kgr06",
    "name": "Sylvia",
    "url": "https://nookipedia.com/wiki/Sylvia",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "pig15",
    "name": "Kevin",
    "url": "https://nookipedia.com/wiki/Kevin",
    "skin_color": "ffaa3b",
    "text_color": "874c25"
  },
  {
    "id": "mnk04",
    "name": "Monty",
    "url": "https://nookipedia.com/wiki/Monty",
    "skin_color": "acc8cf",
    "text_color": "498992"
  },
  {
    "id": "goa06",
    "name": "Velma",
    "url": "https://nookipedia.com/wiki/Velma",
    "skin_color": "ff6183",
    "text_color": "fffce9"
  },
  {
    "id": "pbr06",
    "name": "Frank",
    "url": "https://nookipedia.com/wiki/Frank",
    "skin_color": "78dd62",
    "text_color": "28665a"
  },
  {
    "id": "pig14",
    "name": "Chops",
    "url": "https://nookipedia.com/wiki/Chops",
    "skin_color": "d8cc39",
    "text_color": "8b5f57"
  },
  {
    "id": "hip08",
    "name": "Harry",
    "url": "https://nookipedia.com/wiki/Harry",
    "skin_color": "e8b010",
    "text_color": "fffce9"
  },
  {
    "id": "pig01",
    "name": "Truffles",
    "url": "https://nookipedia.com/wiki/Truffles",
    "skin_color": "f993ce",
    "text_color": "fffce9"
  },
  {
    "id": "ham04",
    "name": "Soleil",
    "url": "https://nookipedia.com/wiki/Soleil",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "mus15",
    "name": "Bettina",
    "url": "https://nookipedia.com/wiki/Bettina",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "brd15",
    "name": "Lucha",
    "url": "https://nookipedia.com/wiki/Lucha",
    "skin_color": "ff4040",
    "text_color": "fffad4"
  },
  {
    "id": "crd01",
    "name": "Alli",
    "url": "https://nookipedia.com/wiki/Alli",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "mus04",
    "name": "Samson",
    "url": "https://nookipedia.com/wiki/Samson",
    "skin_color": "acc8cf",
    "text_color": "498992"
  },
  {
    "id": "cow07",
    "name": "Naomi",
    "url": "https://nookipedia.com/wiki/Naomi",
    "skin_color": "3fd8e0",
    "text_color": "fffce9"
  },
  {
    "id": "der10",
    "name": "Chelsea",
    "url": "https://nookipedia.com/wiki/Chelsea",
    "skin_color": "feaaaa",
    "text_color": "fff9f9"
  },
  {
    "id": "gor00",
    "name": "Cesar",
    "url": "https://nookipedia.com/wiki/Cesar",
    "skin_color": "ff791f",
    "text_color": "fff2bb"
  },
  {
    "id": "ost00",
    "name": "Queenie",
    "url": "https://nookipedia.com/wiki/Queenie",
    "skin_color": "a06fce",
    "text_color": "fffce9"
  },
  {
    "id": "rbt20",
    "name": "Toby",
    "url": "https://nookipedia.com/wiki/Toby",
    "skin_color": "fce229",
    "text_color": "479b78"
  },
  {
    "id": "gor11",
    "name": "Rilla",
    "url": "https://nookipedia.com/wiki/Rilla",
    "skin_color": "ff3339",
    "text_color": "fff6f6"
  }
]
}
